module.exports = __webpack_public_path__ + "img/logo-policia.eefb372e.jpeg";